module.exports = __webpack_public_path__ + "media/images/registrations/testimonial_version/bg-03-32fb76080037cd12c8a92345550f7d38.png";